import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getPaymentGatewayById } from '../../services'
import { BankQueryKeys } from '@/modules/bank/keys'
import { GetPaymentGatewayByIdResponse } from '@/modules/bank/type'

export default function useQueryGetPaymentGatewayById(
	id: string,
	props?: UseBaseQueryOptions<GetPaymentGatewayByIdResponse>,
) {
	return useQuery({
		queryKey: [BankQueryKeys.PaymentGatewayById, id],
		queryFn: () => getPaymentGatewayById(id),
		...props,
	})
}
